import { jsx as _jsx } from "react/jsx-runtime";
export function ScreenTabs({ screens = [], value = 0, onChange, style }) {
    return (_jsx("div", { "data-screen-picker": "", role: "group", "aria-label": "Screen", style: { display: "flex", gap: "var(--space-05)", flexWrap: "wrap", ...style }, children: screens.map((name, i) => {
            const chosen = i === value;
            return (_jsx("button", { type: "button", "data-screen-tab": i, "aria-pressed": chosen, onClick: () => onChange && onChange(i), style: {
                    border: "none", margin: 0, cursor: "pointer", whiteSpace: "nowrap",
                    padding: "3px 10px", borderRadius: "var(--radius-item)",
                    fontFamily: "var(--font-sans)", fontSize: "var(--type-small-size)", lineHeight: "var(--type-small-line)",
                    fontWeight: chosen ? 600 : "var(--type-small-weight)",
                    background: chosen ? "var(--well-ink)" : "transparent",
                    color: chosen ? "var(--well)" : "var(--screen-tab-ink, var(--well-mute))",
                }, children: name }, i));
        }) }));
}
